import styled from 'styled-components';

export const ButtonWrapper = styled.div`
    .nextStepButton {
        height: 45px;
        font-size: 14px;
        font-weight: bold;
        font-family: ${props => props.theme.fontStackCommon};
        padding: 22.5px;
        border-radius: 6px;
        transition: all 200ms ease 0s;
        line-height: 0;
        width: 100%;
        position: relative;
        cursor: pointer;
        margin-top: 10px;
    }

    .pay-button:disabled {
        background-color: ${props => props.theme.inactive};
        border-color: ${props => props.theme.inactive};
        cursor: not-allowed;
        opacity: 1;
    }

    .loader-inner {
        margin-top: 10px;
    }

    .error {
        color: ${props => props.theme.errorColor};
        margin-top: 10px;
        text-align: center;
    }
`;



// WEBPACK FOOTER //
// ./src/components/funnel/buttons/ButtonContainerStyle.js